import {Inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Job} from '../interface/job';
import {first} from 'rxjs/operators';
import {DOCUMENT} from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class JobService {

  constructor(
    private httpClient: HttpClient,
    @Inject(DOCUMENT) private document: Document,
  ) { }

  public getJob(uuid: string, asf360: boolean = false): Observable<Job> {
    if (asf360) {
      return this.httpClient.get(`/rest/crm360/job/${uuid}`)
        .pipe(first()) as Observable<Job>;
    }else{
      return this.httpClient.get(`/rest/crm/job/${uuid}`)
        .pipe(first()) as Observable<Job>;
    }
  }

  public downloadFile(uuid: string, asf360: boolean = false): void {
    if (asf360) {
      this.document.location.href = `/rest/crm360/job/${uuid}/downloadFile`;
    }else{
      this.httpClient.get(`/rest/crm/job/${uuid}/signedUrl`)
        .pipe(first())
        .subscribe((result: any) => {
          this.document.location.href = result.url;
        });
    }
  }
}
